import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setRbacPrivileges,
  setRootSubscriptionPrivileges,
  setSubscriptionPrivileges,
} from "../Redux/privilegesSlice";

export default function useSetPrivilegesFromAuth() {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state?.authReducer);
  const FISubscriptionPrivileges = useSelector(
    (state) => state?.privilegesReducer?.FISubscriptionPrivileges?.data,
  );

  useEffect(() => {
    const userPrivileges = authReducer?.userData?.privileges;
    const productPrivileges = authReducer?.userData?.product_Privileges;

    if (!userPrivileges && !productPrivileges) {
      dispatch(setRbacPrivileges([]));
      dispatch(setRootSubscriptionPrivileges([]));
      dispatch(setSubscriptionPrivileges([]));
      return;
    }

    dispatch(setRbacPrivileges(userPrivileges));
    dispatch(setRootSubscriptionPrivileges(productPrivileges));

    if (FISubscriptionPrivileges != null) {
      dispatch(setSubscriptionPrivileges(FISubscriptionPrivileges));
      return;
    }

    dispatch(setSubscriptionPrivileges(productPrivileges));
  }, [
    authReducer?.userData?.privileges,
    authReducer?.userData?.product_Privileges,
    FISubscriptionPrivileges,
    dispatch,
  ]);
}
